import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import Breadcrumb from '../../components/breadcrumbs/Breadcrumb';

import UsersTable from '../../components/users/UsersTable';

function Users() {

  return (
    <div className="uk-container">

      <div data-uk-grid>

        <div className="uk-width-3-4">
          <Breadcrumbs>
            <Breadcrumb><NavLink to="/">Панель администратора</NavLink></Breadcrumb>
            <Breadcrumb><span>Пользователи</span></Breadcrumb>
          </Breadcrumbs>
        </div>

      </div>

      <h1 className="uk-heading-line uk-text-center">
        <span>Пользователи</span>
      </h1>

      <h1 className="uk-heading-divider"></h1>

      <UsersTable />

    </div>
  )
}

export default Users;
